// extracted by mini-css-extract-plugin
export var root = "uVf0";
export var rootBadges = "_6tox";
export var rootDates = "TSQM";